export default {
  CLEAR_REGISTERBANKINVOICE_STATE: 'CLEAR_REGISTERBANKINVOICE_STATE',
  SET_SELECTED_CLIENT: 'SET_SELECTED_CLIENT',
  SET_REGISTER_BANK_INVOICE_STATE: 'SET_REGISTER_BANK_INVOICE_FORM_STATE',
  RESET_CONFIRMATION_RESULT: 'RESET_CONFIRMATION_RESULT',
  ADD_REGISTER_BANK_INVOICE_STATE: 'ADD_REGISTER_BANK_INVOICE_STATE'
};
